import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SiteLayout from "./components/SiteLayout";
import Index from "./pages/Index";
import Services from "./pages/Services";
import ServiceDetail from "./pages/ServiceDetail";
import APropos from "./pages/APropos";
import FAQ from "./pages/FAQ";
import Blog from "./pages/Blog";
import BlogArticle from "./pages/BlogArticle";
import BlogTag from "./pages/BlogTag";
import Contact from "./pages/Contact";
import MentionsLegales from "./pages/MentionsLegales";
import PolitiqueConfidentialite from "./pages/PolitiqueConfidentialite";
import Confirmation from "./pages/Confirmation";
import NotFound from "./pages/NotFound";
import VilleDetail from "./pages/VilleDetail";
import Portfolio from "./pages/Portfolio";
import PortfolioCategory from "./pages/PortfolioCategory";
import PortfolioAll from "./pages/PortfolioAll";
import Artistes from "./pages/Artistes";
import CrmPro from "./pages/CrmPro";
import ResetPassword from "./crm/auth/ResetPassword";
import Unsubscribe from "./pages/Unsubscribe";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,        // 1 min : données fraîches, pas de refetch inutile
      gcTime: 5 * 60_000,       // 5 min en cache mémoire
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Index />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/a-propos" element={<APropos />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/portfolio/tous" element={<PortfolioAll />} />
            <Route path="/portfolio/:category" element={<PortfolioCategory />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/tag/:tag" element={<BlogTag />} />
            <Route path="/blog/:slug" element={<BlogArticle />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/politique-de-confidentialite" element={<PolitiqueConfidentialite />} />
            <Route path="/confirmation" element={<Confirmation />} />
            <Route path="/ville/:slug" element={<VilleDetail />} />
            <Route path="/artistes" element={<Artistes />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          {/* CRM Pro – application autonome (hors SiteLayout) */}
          <Route path="/crm-pro-evenementiel/*" element={<CrmPro />} />
          <Route path="/definir-mot-de-passe" element={<ResetPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
